import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { getApiData } from "../../helpers/AxiosInstance";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Form from "./Form";
import { getKey } from "../../helpers/sessionKey";
import usePostHook from "../../customHooks/usePostHook";
import { useNavigate, useParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import usePermission from "../../customHooks/usePermission";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateDailyNoteValidationForm } from "../../validation/DailyNote/DailyNoteSchem";

const EditDailyNote = (props: any) => {
  const params = useParams();
  const { handleEdit, isLoading, data, handleMarkAsDone, isMarkasDoneloading } =
    props;

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["daily-note", `daily-note-${params.id}`],
    navigateURL: "",
  });

  const handleReview = async (values: any, setError: any) => {
    const url = `${APIS.DAILY_NOTE}${params.id}/review/`;
    try {
      const res = await mutateAsync({ url, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const handlePrepared = async (values: any, setError: any) => {
    const url = `${APIS.DAILY_NOTE}${params.id}/prepare/`;
    try {
      const res = await mutateAsync({ url, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const handleApproved = async (values: any, setError: any) => {
    const url = `${APIS.DAILY_NOTE}${params.id}/approve/`;
    try {
      const res = await mutateAsync({ url, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const {
    setValue,
    getValues,
    setError,
    register,
    handleSubmit,
    watch,
    control,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(CreateDailyNoteValidationForm),
    defaultValues: async () => {
      return {
        ...data,
      };
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const isSuperUser = getKey("is_superuser") === "true";
  const navigate = useNavigate();
  return (
    <>
      <Card>
        <form
          className={tw``}
          onSubmit={handleSubmit((data) => handleEdit(data, setError))}
        >
          <Form
            errors={errors}
            register={register}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            fields={fields}
            watch={watch}
            isActive={data?.is_active}
            isSuperUser={isSuperUser}
            remove={remove}
            append={append}
          />
          <div className={tw`flex justify-end w-full gap-x-4 px-4`}>
            <div className={tw`w-32`}>
              <Button
                type="button"
                label={
                  data?.status === "DRAFT"
                    ? "Mark as Prepared"
                    : data?.status === "PREPARED"
                    ? "Mark as Reviewed"
                    : data?.status === "REVIEWED"
                    ? "Approve"
                    : "Approved"
                }
                isLoading={isPostLoading}
                disabled={data?.status === "APPROVED"}
                onClick={handleSubmit(async (values) => {
                  try {
                    if (data?.status === "DRAFT") {
                      await handlePrepared(values, setError);
                      navigate(`/daily-notes`, {
                        state: { refresh: true },
                      });
                    } else if (data?.status === "PREPARED") {
                      await handleReview(values, setError);
                      navigate(`/daily-notes`, {
                        state: { refresh: true },
                      });
                    } else if (data?.status === "REVIEWED") {
                      if (!isSuperUser) return;
                      await handleApproved(values, setError);
                      navigate(`/daily-notes`, {
                        state: { refresh: true },
                      });
                    }
                  } catch (err) {
                    console.error(err);
                  }
                })}
              />
            </div>

            <div className={tw`w-24`}>
              <Button
                type="submit"
                label="Update"
                isLoading={isLoading}
                disabled={data?.status === "APPROVED"}
              />
            </div>
          </div>
        </form>
      </Card>
    </>
  );
};

export default EditDailyNote;

